import { P } from 'components'
import PMBInputNumber from 'components/PMBInputNumber'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { Button, FormGroup, Modal, ModalBody } from 'reactstrap'
import { formatInputNumber } from 'utility/Utils'
import { generatePNBPExcel } from '../downloadReport'

const ModalInputDownload = ({ isOpen, toggle, dataReportById }) => {
  const { enqueueSnackbar } = useSnackbar()
  const inputRef = useRef(null)
  const [payload, setPayload] = useState({
    code: '',
    totalCapacity: '',
  })

  // AUTO FOCUS
  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 100)
  }, [isOpen])

  // RESET STATE PAYLOAD
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => {
        setPayload({
          code: '',
          totalCapacity: '',
        })
      }, 300)

      return () => clearTimeout(timeout)
    }
  }, [isOpen])  

  const handleSubmit = () => {
    generatePNBPExcel(
      dataReportById?.itemConfigurations,
      payload?.totalCapacity,
    )
    setTimeout(() => {
      enqueueSnackbar('Berhasil unduh', { variant: 'success' })
      toggle()
    }, 1000)
  }

  return (
    <>
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        style={{ maxWidth: '600px' }}
        data-testid="pnbp-modal-download"
      >
        <ModalBody>
          <div className="d-flex flex-column gap-1">
            <P className="text-sm pb-4" size="medium" color="#101828" bold>
              Administrasi Buku Ukur dan Laporan Produksi Pembayaran
            </P>
          </div>

          {/* <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                Kode<span style={{ color: '#b42218' }}>*</span>
              </P>
            </div>
            <Input
              ref={inputRef}
              placeholder="Masukkan kode (contoh: KTH.GRM)"
              autoComplete="off"
              name="code"
              id="code"
              onChange={(e) => setPayload({ ...payload, code: e.target.value })}
              value={payload?.code ?? null}
              invalid={!payload.code}
              autoFocus
            />
          </FormGroup> */}

          <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                Kapasitas Angkut Truck
                <span style={{ color: '#b42218' }}>*</span>
              </P>
            </div>
            <PMBInputNumber
              id="totalCapacity"
              name="totalCapacity"
              value={formatInputNumber(payload?.totalCapacity)}
              onChange={(e) =>
                setPayload({ ...payload, totalCapacity: e.target.value })
              }
              placeholder="Masukkan kapasitas"
              min={1}
              prefix="Ton"
              isLastPrefix
            />
          </FormGroup>

          <div className="d-flex gap-3 mt-3">
            <Button
              onClick={() => toggle()}
              className="btn-cancel"
              outline
              block
              data-testid="pnbp-modal-download-cancel"
            >
              Batal
            </Button>
            <Button
              color="primary"
              block
              disabled={!payload?.totalCapacity}
              onClick={handleSubmit}
              data-testid="pnbp-modal-download-submit"
            >
              Unduh
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalInputDownload
